module.exports = __webpack_public_path__ + "static/media/hero.add1851a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/mijnbedrijf/hero.jpg
// module id = 928
// module chunks = 0